// src/pages/AdvisorIntakePage.js
//
// Ticket 073 (Advisor Intake I9). The /advisor/intake route: the same IntakePage
// with a fixed mode="advisor", for the client the advisor chose on /advisor/clients.
//
// The client travels in router state (set by AdvisorClientsPage), never in a URL
// (Gate B, rule 8). A refresh drops router state in some browsers: with no client
// the page returns to the list, and nothing saved is lost (Open resumes it).
// IntakePage itself stays router-free so its client-mode tests are unchanged.

import React from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import IntakePage from './IntakePage'

export const ADVISOR_CLIENTS_PATH = '/advisor/clients'

export default function AdvisorIntakePage() {
  const location = useLocation()
  const navigate = useNavigate()
  const subjectId = location.state && typeof location.state.subjectId === 'string' ? location.state.subjectId : null
  if (!subjectId) return <Navigate to={ADVISOR_CLIENTS_PATH} replace />
  return <IntakePage mode="advisor" subjectId={subjectId} onLeave={() => navigate(ADVISOR_CLIENTS_PATH)} />
}
